import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import ImageTag from "../components/reuseable/imageTag";
import { ChevronLeft, Info, AlertCircle, XCircle } from "lucide-react";

function AccountApproval() {
  const location = useLocation();

  const [rejectionData, setRejectionData] = useState(null);

  useEffect(() => {
    // Get rejection data from location state
    const data = location.state?.rejectionData;
    if (data) {
      setRejectionData(data);
    }
  }, [location]);

  // Map enum reason types to user-friendly messages
  const getReasonText = () => {
    if (!rejectionData?.reasonType) return null;

    const reasonTypeMap = {
      MISSING_DETAILS: "Missing Details",
      EXPIRED_DOCUMENTS: "Expired Documents",
      RESTRICT_ACCOUNT: rejectionData.detail
        ? `Your account has been blocked: ${rejectionData.detail}`
        : "Your account has been blocked. Please contact the administrator for more information.",
      OTHER: rejectionData.detail || "Other reason",
    };

    return reasonTypeMap[rejectionData.reasonType] || rejectionData.reasonType;
  };

  const isRestricted = rejectionData?.reasonType === "RESTRICT_ACCOUNT";

  return (
    <div className="lg:h-screen flex items-center">
      <div className="flex w-full lg:h-screen rounded-xl">
        <div className="w-[60%] h-full hidden lg:flex lg:flex-col justify-center items-center bg-gradient-to-b from-[#3FC4E3] to-[#006077]">
          <ImageTag
            path="/assets/images/auth/thumbnail.png"
            classes="size-[460px]"
            altText="login"
          />
          <p className="font-popinsBold text-white text-4xl mt-8 text-center w-[70%]">
            One Platform. Endless Community Possibilities.
          </p>
        </div>
        <div className=" w-full lg:w-[40%] h-screen lg:h-full my-auto flex flex-col items-center justify-center bg-bg-auth bg-no-repeat bg-center bg-cover">
          <div className="w-[90%] lg:w-[75%] mx-auto flex flex-col items-center justify-center h-full">
            <div className="h-full">
              <div className="h-[20%] flex items-center">
                <Link
                  to={"/"}
                  className="relative overflow-hidden py-2 px-4 border-2 border-gray-400 text-gray-600 font-popinsMedium text-sm rounded-md
                   transform transition duration-300 ease-in-out
                   hover:border-gray-500 hover:text-gray-700 hover:bg-gray-50
                   active:scale-95 focus:outline-none
                   flex items-center gap-x-2"
                >
                  <ChevronLeft size={16} />
                  <span>Back to Login</span>
                </Link>
              </div>
              <div className="h-[80%] flex items-center">
                {rejectionData ? (
                  <div className="bg-white border-2 border-[#3FC4E3] justify-center text-center flex flex-col items-center px-6 py-14 rounded-md w-full">
                    {isRestricted ? (
                      <XCircle size={45} className="text-[#DC2626]" />
                    ) : (
                      <AlertCircle size={45} className="text-[#F59E0B]" />
                    )}
                    <p
                      className={`font-bold text-2xl w-[80%] mx-auto mt-4 ${isRestricted ? "text-[#DC2626]" : "text-black"}`}
                    >
                      {isRestricted ? "Account Blocked" : "Account Rejected"}
                    </p>
                    {isRestricted ? (
                      <p className="text-[#424242] font-popinsRegular mt-2 text-sm">
                        {getReasonText()}
                      </p>
                    ) : (
                      <div className="text-[#424242] font-popinsRegular mt-2 text-sm">
                        <p>
                          Your account approval was rejected because of the
                          following reason:
                        </p>
                        <p className="font-bold mt-2">{getReasonText()}</p>
                      </div>
                    )}
                    {!isRestricted && (
                      <Link
                        to="/signup"
                        className="mt-6 px-6 py-2 bg-[#3FC4E3] text-white font-popinsSemiBold rounded-md hover:bg-[#35B0D0] transition-colors"
                      >
                        Sign Up Again
                      </Link>
                    )}
                  </div>
                ) : (
                  <div className="bg-[#3FC4E3] justify-center text-center flex flex-col items-center px-6 py-14 rounded-md w-full">
                    <Info size={45} color="#3C3C3C" />
                    <p className="font-bold text-2xl w-[80%] mx-auto mt-4">
                      Account Approval is in Process
                    </p>
                    <p className="text-[#424242] font-popinsRegular mt-2">
                      Thank you for your patience
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountApproval;
